var React = require('react');

function Line (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M249.427,28.323,229.552,11.456H-130V7.35H231.3l18.123,15.378L267.544,7.35H628.857v4.106H269.3Z","transform":"translate(130.003 -7.35)","fill":"#cce1f1"}));
}

Line.defaultProps = {"viewBox":"0 0 758.86 20.973"};

module.exports = Line;

Line.default = Line;
